import React from 'react';
import { StyledDivider } from './style';

const Divider = () => {
  return (
    <StyledDivider/>
  );
};

export default Divider;
